module.exports = __webpack_public_path__ + "images/digitalethnography.png?v=bc39bc43733b76a07e434da2c2144059";